import { Button, Form, Input, message, Select, Checkbox, Popconfirm } from "antd";
import { useEffect, useState, useRef } from "react";
import { serverFetch } from "../../../server";
import { CloseOutlined } from "@ant-design/icons";
import { messagePatternVids } from "../../../extensions/helper";
import { useSelector } from "react-redux";

const { TextArea } = Input;

const defaultItem = { vid: 0, srok: 0, active: true };

const MessagePattern = ({ id, onClose }) => {
  const [item, setItem] = useState(defaultItem);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const user = useSelector((s) => s.user);
  const mouseDownInsideRef = useRef(false);
  const modalContentRef = useRef(null);

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`MessagePattern/${id}`)
        .then(data => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } else {
      // Для нового шаблона устанавливаем companyId из текущего пользователя
      const defaultFormData = {
        ...defaultItem,
        companyId: user.companyId,
      };
      form.setFieldsValue(defaultFormData);
      setItem({ ...item, ...defaultFormData });
    }
  };

  useEffect(getData, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const onValuesChange = (changedValues, allValues) => {
    setItem({ ...item, ...changedValues });
  };

  const onSave = () => {
    form.validateFields().then(() => {
      setLoading(true);
      serverFetch("MessagePattern", { method: id ? "PUT" : "POST", bodyData: item })
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  const onDelete = () => {
    setLoading(true);
    serverFetch(`MessagePattern/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return (
    <div className="sport-modal">
      <div 
        className="sport-modal-overlay" 
        onMouseDown={e => {
          if (e.target === e.currentTarget) {
            mouseDownInsideRef.current = false;
          }
        }}
        onClick={e => {
          if (e.target === e.currentTarget && !mouseDownInsideRef.current) {
            onClose(false);
          }
        }}
      >
        <div 
          ref={modalContentRef}
          className="sport-modal-content" 
          style={{ width: 900 }}
          onMouseDown={(e) => {
            e.stopPropagation();
            mouseDownInsideRef.current = true;
          }}
          onMouseUp={() => {
            mouseDownInsideRef.current = false;
          }}
        >
          <div className="sport-section-title">
            <span>{id ? "Шаблон сообщения" : "Новый шаблон"}</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} />
          </div>
          <Form form={form} layout="vertical" onValuesChange={onValuesChange} >
            <Form.Item name="name" label="Название" rules={[{ required: true, message: "Введите название шаблона" }]} >
              <Input placeholder="Название шаблона" />
            </Form.Item>
            <Form.Item name="vid" label="Вид" rules={[{ required: true, message: "Выберите вид шаблона" }]}>
              <Select options={messagePatternVids} placeholder="Выберите вид" />
            </Form.Item>
            <Form.Item name="srok" label="Срок (количество дней)" rules={[{ required: true, message: "Введите срок" }]}>
              <Input type="number" placeholder="0" />
            </Form.Item>
            <Form.Item name="body" label="Текст сообщения" rules={[{ required: true, message: "Введите текст сообщения" }]}>
              <TextArea rows={6} placeholder="Текст сообщения. Можно использовать плейсхолдеры: {{CompanyName}}, {{ClientName}}, {{Days}}"/>
            </Form.Item>
            <Form.Item name="active" valuePropName="checked">
              <Checkbox>Активен</Checkbox>
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
              <div>
                {id && (
                  <Popconfirm title="Удалить шаблон?" description="Это действие нельзя отменить" onConfirm={onDelete} okText="Да" cancelText="Нет">
                    <Button danger loading={loading}>Удалить</Button>
                  </Popconfirm>
                )}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <Button onClick={() => onClose(false)}>Отмена</Button>
                <Button type="primary" onClick={onSave} loading={loading}>Сохранить</Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default MessagePattern;
